export default "__VITE_ASSET__169a4f78__"